import React from "react";
import SharedVariablePreviewPage from "~/areas/projects/components/Variables/VariablePreview/SharedVariablePreviewPage";
export function BranchVariablePreviewPage() {
    return <SharedVariablePreviewPage />;
}
